export enum CustomerApplicationType {
    SHORT = 'application.applications-overview.one-week',
    LONG = 'application.applications-overview.two-weeks'
}
